import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import _ from 'lodash';

import { AppState } from '.';
import { cancelStarImage } from './image';
import { postGetMaterialList, postGetWebPaintStyle } from '../api/material';
import {
  AvatarStyleElem,
  EMaterialType,
  IGetMaterialListReq,
  IMaterialAvatarData,
} from '../types/material';

export const getImageLibraryList = createAsyncThunk(
  'imageLibrary/getImageLibraryList',
  async (_, { rejectWithValue, getState }) => {
    try {
      const {
        imageLibrary: {
          image: { page, size },
        },
        user: { authData },
      } = getState() as AppState;
      return await postGetMaterialList(
        {
          page,
          size,
          get_material_list_req_filter: {
            material_type: EMaterialType.MaterialType_Avatar,
            user_id: authData.userId,
          },
        },
        { params: { authData } }
      );
    } catch (err) {
      return rejectWithValue(err);
    }
  }
);

export const queryAllWebPaintStyle = createAsyncThunk(
  'imageLibrary/queryAllWebPaintStyle',
  async (_, { getState }) => {
    const {
      user: { authData },
    } = getState() as AppState;
    return await postGetWebPaintStyle({}, { params: { authData } });
  }
);

export interface IImageLibraryState {
  image: {
    data: IMaterialAvatarData[];
    page: number;
    hasMore: boolean;
    loading: boolean;
    size: number;
  };
  webStyleMap: Record<string, AvatarStyleElem>;
}

const initialState: IImageLibraryState = {
  image: {
    data: [],
    page: 0,
    hasMore: true,
    loading: false,
    size: 20,
  },
  webStyleMap: {},
};

export const imageLibrarySlice = createSlice({
  name: 'imageLibrary',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getImageLibraryList.pending, (state) => {
        state.image.loading = true;
      })
      .addCase(getImageLibraryList.fulfilled, (state, action) => {
        state.image.data = _.uniqBy(
          [...state.image.data, ...(action.payload.material_avatar_data_list || [])],
          'material_id'
        );
        state.image.hasMore = action.payload.has_more || false;
        state.image.page += 1;
        state.image.loading = false;
      })
      .addCase(getImageLibraryList.rejected, (state) => {
        state.image.loading = false;
        state.image.hasMore = false;
      });
    builder.addCase(cancelStarImage.fulfilled, (state, action) => {
      state.image.data = state.image.data.filter(
        (item) => item.material_id !== action.payload.materialId
      );
    });
    builder.addCase(queryAllWebPaintStyle.fulfilled, (state, action) => {
      if (action.payload?.avatar_style_list?.[0]) {
        action.payload.avatar_style_list[0].forEach((item) => {
          if (item.avatar_style_id) state.webStyleMap[item.avatar_style_id] = item;
        });
      }
    });
  },
});
